import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/tops")({
  beforeLoad: () => {
    throw redirect({
      to: "/collections/$collection",
      params: { collection: "tops" },
      statusCode: 301,
    });
  },
});
